<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<p-dialog styleClass="a4-dialog condensed"
          modal="true"
          header="{{'terms-and-conditions.preview-title' | translate}}"
          [visible]="displayDialog()"
          (visibleChange)="displayDialog.set($event)"
          [style]="{'text-transform': 'none'}"
          [draggable]="false"
          (click)='$event.stopPropagation()'
          [dismissableMask]='true'
          (onHide)="hideDialog()">
  <ng-template pTemplate="content">
    @if(!template()) {
      <div class="m-auto">
        <span class="m-auto">{{'terms-and-conditions.not-found' | translate}}</span>
      </div>
    }
    @else {
      <div class="full-height overflow-scroll text-align-justify">
        <div [innerHTML]="template() | safe : 'html'"></div>
      </div>
    }
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="status-wrapper text-align-left" *ngIf="comments()">
      <span class="bold">{{'terms-and-conditions.comments' | translate}}</span>
      <p class="my-sm comments overflow-scroll">{{comments()}}</p>
    </div>

    <div *ngIf="status() && status() !== 'created'" class="text-align-center">
      <p class="mt">{{'terms-and-conditions.currentStatus' | translate}}
        <span class="bold" [ngClass]="{'color-info': status() === 'accepted',
                                         'color-danger': status() !== 'accepted'}">
            {{('terms-and-conditions.statuses.' + status()) | translate}}
          </span>
      </p>
    </div>

    <div class="text-align-center mt-sm actions-wrapper">
      <ng-content select="[actions]"></ng-content>
    </div>
  </ng-template>
</p-dialog>


